<template>
<transition name="modal">
	<div class="modal-mask">
		<div class="modal-wrapper">
			<div class="modal-container-wrapper">
			<div class="modal-container">
				<div class="modal-window-tab-mark">
				</div>
				<div class="modal-close-button" @click="$emit('close')"><img alt="סגור" src="images/x.png" class="fillImg" /></div>
				<div class="modal-wndow-content">
					<div class="modal-wndow-content-title">
						<h3>הרשמה לאודישן</h3></div>
					<div class="login-state">
						<div class="login-state-tab stateActive">פרטים</div>
						<div class="login-state-tab-divider"><img src="images/arrow-next.png" alt="הבא" class="fillImg" /></div>
						<div class="login-state-tab" :class="{stateActive : loginState > 0 }">תשלום</div>
					</div>
					<div class="login-info" v-if="loginState == 1">
						<p>המערכת ממתינה לקבלת אישור התשלום, אנא המתינו</p>
						<p>במידה ולא השלמתם את התשלום וברצונכם לעבור לתשלום פעם נוספת אנא לחצו עם הפתור הבא</p>
						<label class="login-next-button"
									v-on:click="moveToPayment()">מעבר לתשלום</label>
					</div>
					<div class="login-info" v-if="loginState == 0">
						<div class="login-input-line errorMessage" >
							{{validationMessage}}
						</div>
						<div class="login-input-line">
							<input class="login-input" autocomplete="off" v-on:keyup.enter="focusNext(2)" @focus="onNameInput($event.target.value)" placeholder="שם פרטי ושם משפחה" v-bind:value="nameInput" id="nameInputID" @input="onNameInput($event.target.value)" />
						</div>
						<div  id="selectLine" class="login-input-line">
							<div class="login-select">
								<select option v-on:keyup.enter="focusNext(3)" v-if="!adminContext" id="LogininstrumentSelect"
													v-model:value="instrumentInput"
													onfocus="this.style.color='#c7b7a5';this.size=10;this.oldHeight=this.style.height;this.style.height='150px'"
													onblur='this.style.color="#FF632B";this.size=1;this.style.height=this.oldHeight'
													onchange='this.size=1; this.blur();'>
									<option>כלי נגינה ראשי</option>
							<option>גיטרה חשמלית</option>
							<option>גיטרה אקוסטית</option>
							<option>בס</option>
							<option>קלידים</option>
							<option>חליליות</option>
							<option>סקסופון אלט</option>
							<option>סקסופון טנור</option>
							<option>סקסופון בריטון</option>
							<option>סקסופון סופרן</option>
							<option>קלרינט</option>
							<option>מפוחית</option>
							<option>חליל צד</option>
							<option>חצוצרה</option>
											<option>טרומבון</option>
							<option>תופים</option>
							<option>כלי הקשה</option>
							<option>כלי פריטה אחרים</option>
							<option>כלי קשת</option>
							<option>אני רב כלי</option>
								</select>
									<select option v-on:keyup.enter="focusNext(3)" v-if="adminContext" id="LogininstrumentSelect"
													v-model:value="instrumentInput"
													onfocus="this.style.color='#c7b7a5';this.size=10;this.oldHeight=this.style.height;this.style.height='150px'"
													onblur='this.style.color="#FF632B";this.size=1;this.style.height=this.oldHeight'
													onchange='this.size=1; this.blur();'>
					<option>כלי נגינה ראשי</option>
					<option>גיטרה חשמלית</option>
					<option>גיטרה אקוסטית</option>
					<option>בס</option>
					<option>קלידים</option>
					<option>חליליות</option>
					<option>סקסופון אלט</option>
					<option>סקסופון טנור</option>
					<option>סקסופון בריטון</option>
					<option>סקסופון סופרן</option>
					<option>קלרינט</option>
					<option>מפוחית</option>
					<option>חליל צד</option>
					<option>חצוצרה</option>
									<option>טרומבון</option>
					<option>תופים</option>
					<option>כלי הקשה</option>
					<option>כלי פריטה אחרים</option>
					<option>כלי קשת</option>
					<option>שירה</option>
					<option>אני רב כלי</option>
								</select>
							</div>
						</div>
						<div class="login-input-line">
							<input v-on:keyup.enter="focusNext(4)" id="emailInputID" class="login-input"
										autocomplete="off"
										placeholder="אימייל"
										v-bind:value="emailInput"
										 @input="onEmailInput($event.target.value)" />
							<div id="email-info" class="login-content-info">למייל זה נשלח אליך את החשבונית ואת ההנחיות לאודישן.
ודא שהכתובת תקינה</div>
						</div>
						<div class="login-input-line">
						<input v-on:keyup.enter="focusNext(5)" dir="ltr" class="login-input" id="kphoneInputID"  autocomplete="off" placeholder="נייד" v-bind:value="phoneInput" @focus="onPhoneInput($event.target.value)" @input="onPhoneInput($event.target.value)" />
						</div>

						<label class="login-next-button"
									v-on:click="registerUser()">הבא</label>

					</div>
				</div>
				<div class="modal-bottom-image"><img src="images/logo.png" alt="החצר" class="fillImg" /></div>
			</div>
			</div>
		</div>
	</div>
</transition>
</template>

<script>
import axios from 'axios'
import VueScrollTo from 'vue-scrollto'
var APIbase = "https://yard-bands.herokuapp.com"
export default {
	components: {},
	props: ['userId','auditionType','branchInput','adminContext'],
	created() {
	if(!this.adminContext) {
		fbq('track', 'AddToCart');
	}
		console.log(this.auditionType);
		if (this.auditionType == 'Ensemble') {
			this.instrumentInput = 'שירה'
		}
	},
	data() {
		return {
			nameInput : "",
			instrumentInput : "כלי נגינה ראשי",
			emailInput : "",
			phoneInput : "",
			validationMessage : "",
			loginState: 0,
			refreshId:0
		}
	},
	watch: {
		instrumentInput: function (val) {
			if (val === "כלי נגינה ראשי") {
				document.getElementById("LogininstrumentSelect").style.color = "#c7b7a5";
			}
			this.$forceUpdate();
		}
	},
	methods: {
		focusNext(num) {
			if (num == 1) {
				document.getElementById("nameInputID").focus();
			}
			if (num == 2) {
				document.getElementById("LogininstrumentSelect").focus();
			}
			else if (num == 3) {
			 document.getElementById("emailInputID").focus();
			}
			else if (num == 4) {
			 document.getElementById("kphoneInputID").focus();
			}
			else {
				this.registerUser();
			}
		},
		watch_payment() {
			window.addEventListener("message", (event) => {
			// For security: check the origin of the message
			console.log("Received message from inner iframe:", event.data);
			if (event.origin.indexOf("yardbands.com") < 0) return;
				
				axios.post(`${APIbase}/v2/payment_sumit`, {
				'user_id': this.userId,
				'site': this.branchInput
				}).then(response => {
					if(!this.adminContext) {
						try {
							gtag('event', 'conversion', {
							'send_to': 'AW-864508926/7M9VCPOVinwQ_rednAM',
							'value': 185.0,
							'currency': 'ILS'
							});
						} catch (err) {
							console.error('Error triggering gtag event:', err);
						}
						try {
							fbq('track', 'Purchase', { value: '185.00', currency: 'ILS' });
						} catch (err) {
							console.error('Error triggering fbq event:', err);
						}
						if (this.branchInput == "north") {
							window.location = 'https://yardbands.com/thankyouhaifa';
						}
						else {
							window.location = 'https://yardbands.com/thankyoutelaviv';
						}
					}
					else {
						window.location = 'https://yardbands.com/thankyouadmin';
					}		
				
				}).catch(error => {
					console.error('Error fetching user details:', error);
				});

			});
		},
		registerUser(){
			this.validateInput()
			if (this.validationMessage === "") {


				if (this.userId != '') {
					axios.post(APIbase+'/v2/create_user',{
										'user_id':this.userId,
										'name':this.nameInput,
										'instrument':this.instrumentInput,
										'email':this.emailInput,
										'phone':this.phoneInput,
										'audition_type':this.auditionType,
										'site': this.branchInput,
										'admin_context': this.adminContext
									}).then(response => {
						this.userId = response.data.user_id;
						localStorage.setItem('userId', this.userId);
						localStorage.setItem('site', this.branchInput);
						this.moveToPayment();
					})
				}
				else {

				}
			}
		},
		moveToPayment(){
		if(!this.adminContext) {
			fbq('track', 'InitiateCheckout');
		}
		localStorage.setItem('userId', this.userId);
		localStorage.setItem('site', this.branchInput);
		this.watch_payment();
		var d,i,s,ho,b;
		d=document;
		i=d.createElement('iframe');
		s=i.style;b=d.body;ho=b.style.overflow;b.style.overflow='hidden';s.position='fixed';s.top=s.left=0;s.zIndex='99999999';
		s.height=s.width='100%';s.border='none';
		// no allow-modals: suppresses the provider's beforeunload "leave site?" dialog on its internal redirect
		i.setAttribute('sandbox', 'allow-scripts allow-forms allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation');
		i.src=('https://pay.sumit.co.il/9n270d/a1nwas/a1nwat/payment/');
		b.appendChild(i);
		this.loginState = 1;

		},
		onEmailInput(val){

			var local_tester = /^[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*/;
			var domain_tester = /[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
			
			var new_emailParts = val.split('@');

			if (new_emailParts.length < 2) {
				if ( (val.length==0 || local_tester.test(val)) && val.length <= 64) {
					this.emailInput = val;
				}
			}
			else if (new_emailParts.length == 2) {
				var old_emailParts = this.emailInput.split('@');
				var result = "";
				if ( (new_emailParts[0].length>0  && !local_tester.test(new_emailParts[0])) || new_emailParts[0].length > 64) {
					result = old_emailParts[0]; 
				}
				else {
					result = new_emailParts[0];
				}
				if ( new_emailParts[1] > 255) {
					if (old_emailParts.length <2 ) {
						result = result + "@";
					}
					else {
						result = result + "@" + old_emailParts[1].trim();
					}
				}
				else {
					result = result + "@" + new_emailParts[1].trim();
				}
				this.emailInput = result.trim();
			}
			this.$forceUpdate();
		},
		onNameInput(val){
			let forbiddenChars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
			let result = Array.from(val).filter(f=> !forbiddenChars.includes(f)).join('');
			if (result.length < val.length) {
				this.validationMessage = "השארת פרטים בעברית בלבד"
			}else {
				this.validationMessage = ""
			}

			this.nameInput = result;
			this.$forceUpdate();
		},
		onPhoneInput(val){
			let allowedChars = "0123456789";
			let result = Array.from(val).filter(f=> allowedChars.includes(f)).join('');
			if (result.length > 10) {
				this.phoneInput = result.substring(0,10);
			}
			else if (result.length <= 2) {
				this.phoneInput = "05";
				this.$forceUpdate();
				window.setTimeout(function() {
					var InputElement = document.getElementById("kphoneInputID");
					InputElement.setSelectionRange(2, 2);
            	}, 1);
			}
			else if (!result.startsWith('05')) {
				var InputElement = document.getElementById("kphoneInputID");
				InputElement.setSelectionRange(this.phoneInput.length, this.phoneInput.length);
			}
			else {
				this.phoneInput = result;
			}
			this.$forceUpdate();

		},
		instrumentSelected(val){

		},
		validateEmail() {
			var tester = /^[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;

				var emailParts = this.emailInput.split('@');

				if (emailParts.length !== 2) {
					return 1;
				}

				var account = emailParts[0];
  				var address = emailParts[1];

 				if (account.length > 64 || address.length > 255) {
					return 2;
				}
			        var domainParts = address.split('.');
  
			        if (domainParts.some(function (part) {
                                         return part.length > 63;
                                 })) {
					return 3;
				}
				if (!tester.test(this.emailInput)) {
					return 4;	
				}
				return 0;

		},
		validateInput() {
			var re = /\S+@\S+\.\S+/;
			if (this.nameInput === "") {
				this.validationMessage = "נא להקליד שם ושם משפחה"
				    }
			else if (this.instrumentInput === "כלי נגינה"
			|| this.instrumentInput === "כלי נגינה ראשי") {

				this.validationMessage = "נא לבחור כלי נגינה ראשי";
			}
			else if (this.emailInput === "") {
				this.validationMessage = "נא להכניס אימייל"
			}
			else if (this.validateEmail() != 0) {
				this.validationMessage = "כתובת האימייל שהוקלדה אינה חוקית"
			}
			else if (this.phoneInput === "") {
				this.validationMessage = "נא להכניס מספר נייד"
			}
			else if (this.phoneInput.length != 10) {
				this.validationMessage = "מספר הנייד צריך להכיל 10 ספרות"
			}
			else {
				this.validationMessage = ""
			}
			this.$forceUpdate();
		}


	}

}
</script>



// WEBPACK FOOTER //
// Login.vue?1ace1bfa